import {
  Button,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  Select,
  Checkbox,
  Autocomplete,
  TextField,
} from '@mui/material';
import { MenuItem } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Calendar } from 'react-multi-date-picker';
import { DateObject } from 'react-multi-date-picker';

import DateRangeComponent from '../DateRangePicker/DateRangeComponent';
import moment from 'moment';
import './FilterLeaves.css';
import { YYYY_MM_DD } from '../../pages/Tasks/TaskConstants';
import {
  APPLY_BUTTON_TEXT,
  CANCEL_BUTTON_TEXT,
  RESET_DATE_RANGE,
} from '../../constants';
import { getUsers } from '../../services/UserService';
import { useDispatch, useSelector } from 'react-redux';
import {
  resetFilterDataState,
  resetSelectedMonthRange,
  setFilterDataState,
  setSelectedMonthRangeState,
} from '../../modules/filter/filterAction';

function GenericFilter(props) {
  const dispatch = useDispatch();
  const filterConfiguration = useSelector((state) => state.filterConfigState);

  const state = useSelector((state) => state.filterState);

  const {
    handleDrawerOpen,
    options,
    disableDateRange,
    monthRangePicker = false,
  } = props;

  const [search, setSearch] = useState(false);
  const [resetDateRange, setResetDateRange] = useState(false);

  const [toSubjects, setToSubjects] = useState([]);

  const [filterFormData, setFilterFormData] = useState(state);
  const [startDate, setstartDate] = useState('');
  const [endDate, setendDate] = useState('');

  const [rangeType, setRangeType] = useState('CUSTOM');

  const selectedRangeState = useSelector(
    (state) => state.selectedMonthRangeState,
  );

  const [selectedMonthRange, setSelectedMonthRange] =
    useState(selectedRangeState);

  const handleMonthRangeChange = ({ value }) => {
    let updatedRange = [];

    if (rangeType === 'QUARTERLY' && value.length === 1) {
      if (value[0].month.index % 3 === 0)
        updatedRange = [value[0], new DateObject(value[0]).add(2, 'month')];
      else if (value[0].month.index % 3 === 1)
        updatedRange = [
          new DateObject(value[0]).subtract(1, 'month'),
          new DateObject(value[0]).add(1, 'month'),
        ];
      else
        updatedRange = [
          new DateObject(value[0]).subtract(2, 'month'),
          value[0],
        ];
    } else if (rangeType === 'MONTHLY') {
      updatedRange = [value[value.length - 1]];
    } else {
      updatedRange = value;
    }
    if (updatedRange.length === 1) {
      setSelectedMonthRange([Number(updatedRange[0]), Number(updatedRange[0])]);

      setFilterFormData({
        ...filterFormData,
        monthRange: [
          updatedRange[0].month.number,
          updatedRange[0].year,
          updatedRange[0].month.number,
          updatedRange[0].year,
        ],
      });
    } else if (updatedRange.length === 2) {
      setSelectedMonthRange([Number(updatedRange[0]), Number(updatedRange[1])]);
      setFilterFormData({
        ...filterFormData,
        monthRange: [
          updatedRange[0].month.number,
          updatedRange[0].year,
          updatedRange[1].month.number,
          updatedRange[1].year,
        ],
      });
    }
  };

  const checkOptions = (str) => {
    if (str?.length > 1) setSearch(true);
    else {
      setSearch(false);
      if (!str.trim()) {
        setFilterFormData((prevData) => {
          const updatedData = { ...prevData };
          delete updatedData.employeeId;
          delete updatedData.employeeName;
          return updatedData;
        });
      }
    }
  };

  const handleCloseDropdown = (event) => {
    setSearch(false);
  };

  const getInputFieldProperty = () => {
    let inputField = filterConfiguration?.inputField;
    if (inputField === undefined) return;
    let inputArray = [];
    Object.entries(inputField)?.map((entry) => {
      inputArray.push([entry[1][0], entry[1][1]]);
    });
    return inputArray;
  };

  const getCheckFieldProperty = () => {
    let checkField = filterConfiguration?.checkField;
    if (checkField === undefined) return;
    let checkArray = [];
    Object.entries(checkField)?.map((entry) => {
      checkArray.push([entry[1][0], entry[1][1]]);
    });
    return checkArray;
  };

  const getDropdownFieldProperty = () => {
    let dropdownField = filterConfiguration?.dropdownField;
    if (dropdownField === undefined) return;
    let dropdownArray = [];
    Object.entries(dropdownField)?.map((entry) => {
      dropdownArray.push([
        entry[1][0],
        entry[1][1],
        entry[1][2],
        entry[1][3],
        entry[1][4],
      ]);
    });
    return dropdownArray;
  };

  const getAutoCompleteFieldProperty = () => {
    let autoCompleteField = filterConfiguration?.autoComplete;
    if (autoCompleteField === undefined) return;
    let autoCompleteArray = [];
    Object.entries(autoCompleteField)?.map((entry) => {
      autoCompleteArray.push([entry[1][0], entry[1][1]]);
    });
    return autoCompleteArray;
  };

  useEffect(() => {
    loadData();
  }, []);

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: 'SHOW_NOTIFICATION',
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const loadData = async () => {
    const subjects = await getUsers('');
    if (!monthRangePicker) dipatchNotification(subjects.type, subjects.message);
    if (subjects.isError === false) {
      setToSubjects(() => subjects.data.content);
    }
  };

  const onDateRangeSelection = (item) => {
    setstartDate(moment(item.startDate).format(YYYY_MM_DD));
    setendDate(moment(item.endDate).format(YYYY_MM_DD));
  };

  const handleApplyClick = () => {
    handleDrawerOpen();
    dispatch(setFilterDataState(filterFormData));
    dispatch(setSelectedMonthRangeState(selectedMonthRange));
  };
  const handleCancelFilter = () => {
    handleDrawerOpen();
    dispatch(resetFilterDataState());
    dispatch(resetSelectedMonthRange());
    dispatch(resetSelectedMonthRange());
    dispatch({
      type: RESET_DATE_RANGE,
    });
  };

  useEffect(() => {
    setstartDate(state.startDate);
    setendDate(state.endDate);
    setFilterFormData(state);
  }, [state]);

  useEffect(() => {
    setFilterFormData({
      ...filterFormData,
      startDate: startDate,
      endDate: endDate,
    });
  }, [startDate, endDate]);

  return (
    <>
      <div className="container">
        {getAutoCompleteFieldProperty() !== undefined
          ? getAutoCompleteFieldProperty()?.map((value, index) => {
              return (
                <div key={index} className="option">
                  <FormControl
                    variant="standard"
                    className="formControlDropdown"
                    sx={{ mr: 1, mt: -1, minWidth: '80%', width: '280px' }}
                  >
                    <Autocomplete
                      value={filterFormData}
                      style={{ marginTop: '0px' }}
                      freeSolo
                      disableClearable
                      id="jhghj"
                      open={search}
                      options={toSubjects?.map((option) => {
                        return {
                          [value[1] + 'Name']:
                            option.firstName + ' ' + option.lastName,
                          [value[1] + 'Id']: option.id,
                        };
                      })}
                      getOptionLabel={(option) =>
                        eval('option.' + value[1] + 'Name')
                          ? eval('option.' + value[1] + 'Name')
                          : ''
                      }
                      onInputChange={(e, val, reason) => {
                        if (reason === 'input') {
                          checkOptions(val);
                        }
                      }}
                      onBlur={handleCloseDropdown}
                      onChange={(e, val) => {
                        if (val) {
                          setFilterFormData({
                            ...filterFormData,
                            [value[1] + 'Name']: val.employeeName,
                            [value[1] + 'Id']: val.employeeId,
                          });
                        }
                        setSearch(false);
                      }}
                      filterSelectedOptions
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label={value[0]}
                        />
                      )}
                      sx={{ mt: 2 }}
                    />
                  </FormControl>
                </div>
              );
            })
          : ''}

        {getDropdownFieldProperty() !== undefined
          ? getDropdownFieldProperty()?.map((value, index) => {
              return (
                <div key={index} className="option">
                  <FormControl
                    variant="standard"
                    className="formControlDropdown"
                    sx={{ mr: 1, mt: -1, minWidth: '80%', width: '280px' }}
                  >
                    <InputLabel id="demo-simple-select-label">
                      {value[0]}
                    </InputLabel>
                    <Select
                      name={value[1]}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={
                        eval('filterFormData.' + value[1] + 'Id')
                          ? eval('filterFormData.' + value[1] + 'Id')
                          : ''
                      }
                      label={value[0]}
                      sx={{ width: '280px' }}
                      onChange={(e) => {
                        const currentVal = options[value[1]].find(
                          (item) => eval('item.' + value[3]) === e.target.value,
                        );
                        if (currentVal) {
                          setFilterFormData({
                            ...filterFormData,
                            [value[1] + 'Name']: eval('currentVal.' + value[2]),
                            [value[1] + 'Id']: eval('currentVal.' + value[3]),
                          });
                        }
                      }}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 400,
                          },
                        },
                      }}
                    >
                      {options[value[1]]?.length > 0 ? (
                        options[value[1]].map((obj) => (
                          <MenuItem
                            value={eval('obj.' + value[3])}
                            key={eval('obj.' + value[3])}
                          >
                            {eval('obj.' + value[2])}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem disabled>No options available</MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </div>
              );
            })
          : ''}

        {getInputFieldProperty() !== undefined
          ? getInputFieldProperty()?.map((value, index) => {
              return (
                <div key={index} className="option">
                  <FormControl
                    sx={{ mr: 1, mt: -1, minWidth: '80%' }}
                    variant="standard"
                    className="formControlDropdown"
                  >
                    <InputLabel id="demo-simple-select-label">
                      {value[0][1]}
                    </InputLabel>
                    <Select
                      name={value[0][0]}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={
                        eval('filterFormData.' + value[0][0])
                          ? eval('filterFormData.' + value[0][0])
                          : ''
                      }
                      label={value[0][1]}
                      sx={{ width: '280px' }}
                      onChange={(event) =>
                        setFilterFormData({
                          ...filterFormData,
                          [event.target.name]: event.target.value,
                        })
                      }
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 400,
                          },
                        },
                      }}
                    >
                      {value[1]?.map((item, key) => {
                        return (
                          <MenuItem key={key} value={item[0]}>
                            {item[1]}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </div>
              );
            })
          : ''}
        {getCheckFieldProperty() !== undefined
          ? getCheckFieldProperty()?.map((value, index) => {
              return (
                <div key={index} className="option" sx={{ mb: '-15px' }}>
                  <FormGroup sx={{ width: '100%' }}>
                    <FormControlLabel
                      value={eval('filterFormData.' + value[0])}
                      control={
                        <Checkbox
                          name={value[0]}
                          checked={
                            eval('filterFormData.' + value[0])
                              ? eval('filterFormData.' + value[0])
                              : false
                          }
                          onChange={(event) =>
                            setFilterFormData({
                              ...filterFormData,
                              [event.target.name]: !eval(
                                'filterFormData.' + value[0],
                              ),
                            })
                          }
                        />
                      }
                      label={value[1]}
                    />
                  </FormGroup>
                </div>
              );
            })
          : ''}

        {disableDateRange ? (
          <div style={{ marginTop: '2.5rem' }}></div>
        ) : (
          <div className="dateRange">
            <DateRangeComponent
              onDateRangeSelection={onDateRangeSelection}
              resetDateRange={resetDateRange}
              setResetDateRange={setResetDateRange}
            />
          </div>
        )}

        {monthRangePicker && (
          <div style={{ marginTop: '5px', height: '385px', width: '100%' }}>
            <Calendar
              onlyMonthPicker
              range={rangeType !== 'MONTHLY'}
              onPropsChange={handleMonthRangeChange}
              value={selectedRangeState.selectedRange}
            />
          </div>
        )}

        <div className="applyAndCancel">
          <Button
            className="applyButton"
            variant="contained"
            tabIndex={0}
            title={APPLY_BUTTON_TEXT}
            aria-label="Apply"
            onClick={handleApplyClick}
          >
            {APPLY_BUTTON_TEXT}
          </Button>
          <Button
            className="cancelButton"
            variant="contained"
            tabIndex={0}
            title={CANCEL_BUTTON_TEXT}
            aria-label="Apply"
            color="error"
            onClick={handleCancelFilter}
          >
            {CANCEL_BUTTON_TEXT}
          </Button>
        </div>
      </div>
    </>
  );
}

export default GenericFilter;
